import React from "react";
import { Input, InputProps } from "reactstrap";
import * as Component from "./components";
import { IControlStyles } from "./components";


export interface ControlProps extends InputProps {
    controlStyles?: IControlStyles | undefined;
    isHidden?: boolean | undefined;
}

export const ComponentProps = (props: ControlProps): InputProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.controlStyles;
    
    return componentProps;
}

const Control: React.FC<ControlProps> = (props) => {    
    return (
        <Input {...ComponentProps(props)}  />
    );
};

export default Object.assign(Control, {
    Autocomplete: Component.ControlAutocomplete,
    Attachments: Component.ControlAttachments,
    Button: Component.ControlButton,
    Checkbox: Component.ControlCheckbox,
    Chip: Component.ControlChip,
    Color: Component.ControlColor,
    DataGrid: Component.ControlDataGrid,
    Date: Component.ControlDate,
    Datetime: Component.ControlDatetime,
    Dropdown: Component.ControlDropdown,
    Email: Component.ControlEmail,
    File: Component.ControlFile,
    Group: Component.ControlGroup,
    Hidden: Component.ControlHidden,
    IconPicker: Component.ControlIconPicker,
    Image: Component.ControlImage,
    ImageUpload: Component.ControlImageUpload,
    Input: Component.ControlInput,
    Label: Component.ControlLabel,
    Month: Component.ControlMonth,
    Number: Component.ControlNumber,
    Password: Component.ControlPassword,
    Phone: Component.ControlPhone,
    Radio: Component.ControlRadio,
    Range: Component.ControlRange,
    Search: Component.ControlSearch,
    Switch: Component.ControlSwitch,
    Text: Component.ControlText,
    TextArea: Component.ControlTextArea,
    Time: Component.ControlTime,
    Url: Component.ControlUrl,
    Week: Component.ControlWeek
});